
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#a)","fill":"#313131"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.5 18.583c0-8.56 6.94-15.5 15.5-15.5 8.56 0 15.5 6.94 15.5 15.5 0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5z"}}),_c('path',{attrs:{"d":"M7.75 53.274c0-9.172 7.435-16.607 16.607-16.607h13.286c9.172 0 16.607 7.435 16.607 16.607a6.643 6.643 0 01-6.643 6.643H14.393a6.643 6.643 0 01-6.643-6.643z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h62v62H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      